import { useEffect, useState, type FormEvent } from "react";
import { api } from "./api";
import { Header } from "./Header";
import { PasswordForm } from "./Password";
import { ROLE_LABEL, useMe, type AppUser } from "./session";
import "./cop.css";

/** My profile: each person sets their own work email (COP and RFI sends go out from it). */
export function Profile({ onSignOut }: { onSignOut: () => void }) {
  const me = useMe();
  const [profile, setProfile] = useState<AppUser | null>(null);
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const [pwDone, setPwDone] = useState(false);
  useEffect(() => { api.profile().then((r) => { setProfile(r.profile); setEmail(r.profile.workEmail ?? ""); }).catch((e) => setMsg({ kind: "error", text: e.message })); }, []);
  const save = async (e: FormEvent) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try { const r = await api.updateProfile({ workEmail: email.trim() }); setProfile(r.profile); setEmail(r.profile.workEmail ?? ""); setMsg({ kind: "ok", text: r.profile.workEmail ? "Work email saved." : "Work email cleared." }); }
    catch (err) { setMsg({ kind: "error", text: (err as Error).message }); } finally { setBusy(false); }
  };
  const sends = me && me.role !== "foreman";
  return (
    <div className="page">
      <Header onSignOut={onSignOut}><span>My profile</span></Header>
      <main className="content cop-page">
        <h2>My profile</h2>
        {msg && <div className={msg.kind === "error" ? "error" : "ok-msg"} role="status">{msg.text}</div>}
        {profile && <form className="card cop-card" onSubmit={save}>
          <div className="cop-kv"><span>Name</span><b>{profile.displayName}</b></div>
          <div className="cop-kv"><span>Username</span><b>{profile.username}</b></div>
          <div className="cop-kv"><span>Role</span><b>{ROLE_LABEL[profile.role]}</b></div>
          <label className="cop-field wide"><span>Work email</span>
            <input type="email" inputMode="email" autoComplete="email" value={email} placeholder="name@watsonconstruct.com" onChange={(e) => setEmail(e.target.value)} /></label>
          {sends && <p className="muted small">Change order proposals and RFIs you send go out from this address.</p>}
          <div className="cop-actions"><button className="primary" disabled={busy}>{busy ? "Saving…" : "Save"}</button></div>
        </form>}
        {profile && <section className="card cop-card" aria-labelledby="pw-h">
          <h3 id="pw-h">Change my password</h3>
          {pwDone && <div className="ok-msg" role="status">Password changed. You're signed out on your other devices.</div>}
          <PasswordForm askCurrent submitLabel="Change password" onDone={() => setPwDone(true)} />
        </section>}
      </main>
    </div>
  );
}
